/**
 * selectedPeriod (#2254) — the page's selected-period discriminated union.
 *
 * A leaf module (no imports) so both the page (URL resolve) and the feeds
 * (window/column selection) can share the type without an import cycle.
 * ``month`` carries the ``?ym=YYYY-MM`` form; ``wj`` carries the
 * ``?wj=YYYY`` start-year form (matching the ``wj-<startYear>`` lens ids).
 */
export type SelectedPeriod =
  | { kind: 'month'; ym: string }
  | { kind: 'wj'; startYear: number };

/**
 * The 'YYYY-MM' the rollup/window math anchors on: the selected month itself,
 * or the WJ's start month — any month inside the WJ maps to the same
 * ``wjWindowOf`` window, so the start month is a faithful anchor for the
 * whole year.
 */
export function periodAnchorYm(period: SelectedPeriod, wjStartMonth: number): string {
  return period.kind === 'month'
    ? period.ym
    : `${period.startYear}-${String(wjStartMonth).padStart(2, '0')}`;
}
